import { z } from "zod/v4";

import { createEndpointBase } from "./core";

const base = "screenshots";
const shots = createEndpointBase(base);

export const screenshotsEndpoints = {
  screenshotsDelete: shots({
    method: "DELETE",
    path: "",
    request: z.object({
      days: z.number().optional(),
      from: z.coerce.date().optional(),
      to: z.coerce.date().optional(),
    }),
    response: z.any(),
    description: "Permanently deletes screenshots based on date range or days offset.",
  }),
} as const;
